import { Box, BoxProps, styled } from '@mui/material';

const StyledProgressLine = styled(Box)<BoxProps>(({ theme }) => ({
  position: 'absolute',
  top: 0,
  height: '1.2rem',
  borderRadius: '0.6rem',
  boxShadow: `0.6rem 0 0 0 ${theme.palette.background.list}`,
}));

export default StyledProgressLine;
